// src/features/tuition/services/tutorialService.js
// This file contains mock service functions for the tutorial management system

// Mock data
const mockTutorials = [
    {
      id: '1',
      title: 'Introduction to Quadratic Equations',
      subject: 's1', // Mathematics
      grade: '10',
      duration: 30,
      description: 'Learn how to solve quadratic equations using various methods.',
      content: '<h2>What are Quadratic Equations?</h2><p>A quadratic equation is a second-degree polynomial equation in a single variable x, where a, b, and c are constants, a ≠ 0.</p><p>ax² + bx + c = 0</p><h3>Methods to Solve Quadratic Equations</h3><ol><li>Factoring</li><li>Completing the Square</li><li>Quadratic Formula</li></ol>',
      thumbnail: {
        url: 'https://images.unsplash.com/photo-1635070041078-e363b712a58b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=60',
        name: 'quadratic_thumbnail.jpg',
        size: 153000
      },
      video: {
        url: 'https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_1mb.mp4',
        name: 'quadratic_intro.mp4',
        size: 1048576
      },
      documents: [
        {
          url: 'https://www.example.com/sample.pdf',
          name: 'Quadratic Equations Formula Sheet.pdf',
          size: 512000
        }
      ],
      images: [
        {
          url: 'https://images.unsplash.com/photo-1596495578065-6e0763fa1178?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=60',
          name: 'quadratic_graph.jpg',
          size: 245000
        }
      ],
      microActivities: [
        {
          id: '1a',
          title: 'Identify Quadratic Equations',
          type: 'quiz',
          description: 'Which of the following is a quadratic equation?',
          timeToComplete: 3,
          isRequired: true,
          isTimestamp: true,
          options: [
            'y = 2x + 3',
            'y = x² + 5x + 6',
            'y = 1/x',
            'y = √x'
          ],
          correctAnswer: 'y = x² + 5x + 6',
          points: 10
        },
        {
          id: '1b',
          title: 'Solving by Factoring',
          type: 'reflection',
          description: 'Explain in your own words how you would solve the equation x² - 4 = 0 by factoring.',
          timeToComplete: 5,
          isRequired: true,
          isTimestamp: true,
          points: 15
        }
      ],
      status: 'published',
      publishedAt: '2025-03-15T10:30:00Z',
      createdAt: '2025-03-10T14:22:00Z',
      updatedAt: '2025-03-15T10:30:00Z',
      userId: 'user1',
      completedActivities: []
    },
    {
      id: '2',
      title: 'Chemical Reactions Basics',
      subject: 's2', // Physical Sciences
      grade: '11',
      duration: 45,
      description: 'Introduction to chemical reactions and balancing chemical equations.',
      content: '<h2>Chemical Reactions</h2><p>A chemical reaction is a process that leads to the chemical transformation of one set of chemical substances to another.</p><h3>Types of Chemical Reactions</h3><ul><li>Synthesis Reactions</li><li>Decomposition Reactions</li><li>Single Replacement Reactions</li><li>Double Replacement Reactions</li></ul>',
      thumbnail: {
        url: 'https://images.unsplash.com/photo-1532094349884-543bc11b234d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=60',
        name: 'chemistry_thumbnail.jpg',
        size: 168000
      },
      documents: [
        {
          url: 'https://www.example.com/sample.pdf',
          name: 'Chemical Reaction Types.pdf',
          size: 725000
        }
      ],
      microActivities: [
        {
          id: '2a',
          title: 'Balance This Equation',
          type: 'quiz',
          description: 'Which is the correctly balanced equation for the reaction between hydrogen and oxygen to form water?',
          timeToComplete: 4,
          isRequired: true,
          isTimestamp: true,
          options: [
            'H + O = H₂O',
            'H₂ + O₂ = H₂O',
            '2H₂ + O₂ = 2H₂O',
            'H₂ + O = H₂O'
          ],
          correctAnswer: '2H₂ + O₂ = 2H₂O',
          points: 10
        }
      ],
      status: 'draft',
      createdAt: '2025-04-05T09:15:00Z',
      updatedAt: '2025-04-05T09:15:00Z',
      userId: 'user1',
      completedActivities: []
    },
    {
      id: '3',
      title: 'Literary Devices in Poetry',
      subject: 's3', // English Language
      grade: '9',
      duration: 25,
      description: 'Learn about metaphors, similes, personification and other literary devices used in poetry.',
      content: '<h2>Literary Devices</h2><p>Literary devices are techniques that writers use to create a special and pointed effect in their writing.</p><h3>Common Literary Devices</h3><ul><li>Metaphor - A comparison between two unlike things</li><li>Simile - A comparison using "like" or "as"</li><li>Personification - Giving human qualities to non-human things</li></ul>',
      thumbnail: {
        url: 'https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=60',
        name: 'poetry_thumbnail.jpg',
        size: 142000
      },
      microActivities: [
        {
          id: '3a',
          title: 'Identify the Device',
          type: 'quiz',
          description: '"Her eyes were like diamonds." This is an example of:',
          timeToComplete: 2,
          isRequired: true,
          isTimestamp: true,
          options: [
            'Metaphor',
            'Simile',
            'Personification',
            'Alliteration'
          ],
          correctAnswer: 'Simile',
          points: 5
        },
        {
          id: '3b',
          title: 'Find Literary Devices',
          type: 'reflection',
          description: 'Read the poem and identify at least two literary devices used. Explain their effect.',
          timeToComplete: 10,
          isRequired: true,
          isTimestamp: true,
          points: 20
        },
        {
          id: '3c',
          title: 'Module Completion',
          type: 'checkpoint',
          description: 'Mark this checkpoint to indicate you have completed this module.',
          timeToComplete: 1,
          isRequired: true,
          isTimestamp: true,
          points: 5
        }
      ],
      status: 'published',
      publishedAt: '2025-02-28T13:45:00Z',
      createdAt: '2025-02-25T16:30:00Z',
      updatedAt: '2025-02-28T13:45:00Z',
      userId: 'user1',
      completedActivities: [
        {
          activityId: '3a',
          completedAt: '2025-03-02T10:23:15Z',
          response: 'Simile',
          correct: true
        }
      ]
    }
  ];
  
  // Mock service functions
  export const fetchTutorials = async (userId) => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 800));
    return mockTutorials;
  };
  
  export const fetchTutorialById = async (tutorialId) => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    const tutorial = mockTutorials.find(t => t.id === tutorialId);
    
    if (!tutorial) {
      throw new Error('Tutorial not found');
    }
    
    return tutorial;
  };
  
  export const createTutorial = async (tutorialData) => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Create a new tutorial with an ID
    const newTutorial = {
      ...tutorialData,
      id: `tutorial_${Date.now()}`,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      completedActivities: []
    };
    
    return newTutorial;
  };
  
  export const updateTutorial = async (tutorialId, tutorialData) => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 1000));
    
    // Find the tutorial to update
    const tutorialIndex = mockTutorials.findIndex(t => t.id === tutorialId);
    
    if (tutorialIndex === -1) {
      throw new Error('Tutorial not found');
    }
    
    // Update the tutorial
    const updatedTutorial = {
      ...mockTutorials[tutorialIndex],
      ...tutorialData,
      updatedAt: new Date().toISOString(),
    };
    
    return updatedTutorial;
  };
  
  export const deleteTutorial = async (tutorialId) => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 800));
    
    return { success: true };
  };
  
  export const publishTutorial = async (tutorialId) => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 600));
    
    return { success: true };
  };
  
  export const unpublishTutorial = async (tutorialId) => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 600));
    
    return { success: true };
  };
  
  export const completeActivity = async (tutorialId, completionData) => {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 800));
    
    return { success: true };
  };